<template lang="pug">

</template>

<script>
export default {
  props: {
    containerId: String,
    newDashboard: { type: Boolean, default: true },
    action: { type: String, default: 'Create Dashboard' }
  },

  data() {
    return {
      showModal: false,
      hideGroups: true,
      widgets: null
    }
  },

  mounted() {
    this.showModules()
  },

  created() {
    this.getModules()
  },

  methods: {
    getModules() {
      this.api.get(this.api.$.dashboard.templates).then(r => {
        if (r && r.data && r.data.length) {
          this.widgets = this.mix(r.data)
          this.save()
        }
      })
    },
    showModules() {
      this.showModal = true
    },

    create(dashboard) {
      if (dashboard.disabled) {
        return false
      }

      if (dashboard.custom) {
        this.showModal = true
        return true
      }
    },
    save() {
      let payload = {
        containerType: 0,
        containerSectionId: this.containerId,
        containerSectionLabel: 'Dashboard',
        widgetTypes: this.getSelectedModules(this.widgets)
      }

      this.api.put(this.api.$.dashboard.create, payload).then(r => {
        const id = r && r.data && r.data.id || null
        this.$parent.getDashboard(id || this.containerId)
      })
    },

    getSelectedModules(modules) {
      return modules.filter(module => module.id).map(module => module.id)
    },

    mix(widgetGroups) {
      let flatList = []

      widgetGroups.forEach(group => {
        flatList.push({
          group: group.name
        })
        flatList.push(...group.widgets)
      })

      return flatList
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/new.vue